import React, { useState } from 'react';
import { Form, Container, Row, Col, Spinner } from 'react-bootstrap';
import { Table, Pagination } from 'antd';
import DriverService from '../../services/DriverService';
import * as XLSX from 'xlsx'; // Import thư viện xlsx
import './style.css'; // Tạo 1 file CSS riêng để căn chỉnh giao diện
import { Input, Button, Tooltip } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const LuongLaiXeKD = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const formatDateToDDMMYYYY = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${day}_${month}_${year}`; // Định dạng dd_mm_yyyy cho tên file
  };

  const timKiem = async () => {
    if (!startDate || !endDate) {
      alert('Vui lòng chọn ngày');
      return;
    }
    setIsLoading(true);
    try {
      const data = await DriverService.load_thong_tin_chuyen_cua_lai_xe(startDate, endDate);
  
      // Tự động tạo columns từ khóa object đầu tiên
      const columnHeaders = data.length > 0 ? Object.keys(data[0]) : [];
  
      const tableColumns = columnHeaders.map((col) => ({
        title: col,
        dataIndex: col,
        key: col,
      }));
  
      setColumns(tableColumns);
      setDataSource(data);
      setTotalRecords(data.length);
    } catch (error) {
      console.error('Lỗi khi tìm kiếm:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const exportToExcel = async () => {
    setIsLoading(true);
    try {
      const headers = columns.map((col) => col.title);
      const exportData = dataSource.map((row) =>
        headers.map((header) => row[header] || '')
      );

      const worksheetData = [headers, ...exportData];
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'LoTrinhNhap');

      const fileName = startDate && endDate
        ? `Du_lieu_luong_KD_${formatDateToDDMMYYYY(startDate)}_${formatDateToDDMMYYYY(endDate)}.xlsx`
        : 'Chuyen_xe_chua_hoan_thanh.xlsx';

      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error('Lỗi khi xuất Excel:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTableChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Tìm kiếm ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => confirm()}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Tìm
        </Button>
        <Button
          onClick={() => clearFilters && clearFilters()}
          size="small"
          style={{ width: 90, marginTop: 8 }}
        >
          Xóa
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) =>
      text && text.length > 20 ? ( // Rút gọn nội dung dài hơn 20 ký tự
        <Tooltip title={text}>
          <span
            style={{
              display: 'inline-block',
              maxWidth: '200px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {text}
          </span>
        </Tooltip>
      ) : (
        text
      ),
  });
  
  // Thêm width mặc định cho cột
  const enhancedColumns = columns.map((col) => ({
    ...col,
    width: 150, // Chiều rộng mặc định cho mỗi cột (có thể điều chỉnh)
    ...getColumnSearchProps(col.dataIndex),
  }));

  return (
    <Container fluid className="my-4" id="xuat-du-lieu-kd">
      <h2 className="text-center mb-4">Lấy dữ liệu KD</h2>

      <Form>
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group controlId="startDate">
              <Form.Label>Ngày bắt đầu:</Form.Label>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group controlId="endDate">
              <Form.Label>Ngày kết thúc:</Form.Label>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="button-row">
          <Button
            variant="danger"
            onClick={timKiem}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{' '}
                Đang tìm kiếm...
              </>
            ) : (
              'Lấy dữ liệu luơng'
            )}
          </Button>

          <Button
            variant="success"
            onClick={exportToExcel}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{' '}
                Đang xuất...
              </>
            ) : (
              'Xuất Excel'
            )}
          </Button>
        </div>
      </Form>

      <Table
        dataSource={dataSource.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
        columns={enhancedColumns}
        pagination={false}
        rowKey={(record) => record.id || Math.random()}
        className="mt-4 custom-table"
        loading={isLoading}
        scroll={{
          x: 'max-content', // Kích hoạt cuộn ngang nếu nội dung vượt quá
          y: 5 * 72, // Chiều cao tối đa (5 dòng x chiều cao ước lượng của 1 dòng)
        }}
      />

      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={totalRecords}
        onChange={handleTableChange}
        className="mt-3"
      />
    </Container>
  );
};

export default LuongLaiXeKD;
